import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { PageHeader } from '../../components/common/PageHeader/PageHeader';
import { CMTableList } from '../../components/common/TableList/TableList';
import { PageRoutes } from '../../constants';
import { AppContext } from '../../components/common/Helpers/Context/AppContext';
import { deleteMedicine, deleteMedicineHard, listPatientMedicine, rollbackMedicine } from './MedicinesServices';

const MedicinesList = () => {

    const { globalData, setGlobalData } = React.useContext(AppContext);

    const columns: readonly any[] = [
        { key: "patient_id", label: "Pateint ID", minWidth: 170 },
    ];

    React.useEffect(() => {
        setGlobalData({
            ...globalData,
            loading: true
        })
        listPatientMedicine().then((res: any) => {
            setGlobalData({
                ...globalData,
                loading: false
            })
        }).catch((err: any) => {
            console.log(err)
            setGlobalData({
                ...globalData,
                loading: false,
                error: true,
                errorMessage: "Failed to load data"
            });
        })
    }, [])
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>

                    <Row>
                        <Col lg={12}>
                            <PageHeader header='Medicine' list={true} link={PageRoutes.MEDICINE_ADD} value={"Add Medicine"}/>

                            <CMTableList
                                listService={listPatientMedicine}
                                deleteService={deleteMedicine}
                                deleteHardService={deleteMedicineHard}
                                rollbackSerivce={rollbackMedicine}
                                showView={false}
                                showBlock={false}
                                editLink={PageRoutes.MEDICINE_EDIT}
                                columns={columns}
                                deleteAccess={true}
                                editAccess={true}
                                noswitch={true}
                            />
                        </Col>
                    </Row>

                </Container>
            </div>
        </React.Fragment>
    );
};

export default MedicinesList;
